export const useTailSpacerDesktop = size => {
  switch (size) {
    case "1":
      return "md:h-1"
    case "2":
      return "md:h-2"
    case "3":
      return "md:h-3"
    case "4":
      return "md:h-4"
    case "5":
      return "md:h-5"
    case "6":
      return "md:h-6"
    case "8":
      return "md:h-8"
    case "10":
      return "md:h-10"
    case "12":
      return "md:h-12"
    case "16":
      return "md:h-16"
    case "20":
      return "md:h-20"
    case "24":
      return "md:h-24"
    case "32":
      return "md:h-32"
    case "40":
      return "md:h-40"
    case "48":
      return "md:h-48"
    case "56":
      return "md:h-56"
    case "64":
      return "md:h-64"
    default:
      return "md:h-0"
  }
}
